<template>
    <div v-if="$showModal('differentShop')" class="custom_popup_wrapper">
        <div class="custom_popup_inner">
            <div
                id="cannot_combined"
                class="b_modal white_modal small_size mfp-hide zoom-anim-dialog"
            >
                <div class="modal_content_inner">
                    <div class="single_modal_title">
                        רגע אחד!<br />
                        לא ניתן לשלב בסל אחד מוצרים מחנויות שונות. מעבר לחנות
                        אחרת יאפס את סל הקניות. <br />
                        מה לעשות?
                    </div>
                    <div class="action_wrapper">
                        <div class="action_row">
                            <label class="label_radio">
                                <input
                                    v-model="selectedOption"
                                    :value="stayOption"
                                    type="radio"
                                    name="cannot_combined"
                                />
                                <span class="label_radio_content">
                                    להמשיך בחנות הנוכחית
                                </span>
                            </label>
                        </div>
                        <div class="action_row">
                            <label class="label_radio">
                                <input
                                    v-model="selectedOption"
                                    :value="clearOption"
                                    type="radio"
                                    name="cannot_combined"
                                />
                                <span class="label_radio_content">
                                    לרוקן הסל ולעבור לחנות אחרת
                                </span>
                            </label>
                        </div>
                    </div>
                    <div class="action_button text_left">
                        <button
                            class="btn btn_template"
                            type="button"
                            :disabled="!selectedOption"
                            @click="confirm"
                        >
                            יאללה
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    props: {
        redirectToCurrentShop: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            selectedOption: null,
            clearOption: 'clear',
            stayOption: 'stay'
        };
    },

    computed: {
        ...mapGetters({
            currentShopId: 'cart/currentShopId'
        })
    },

    methods: {
        ...mapActions({
            clearCart: 'cart/clear'
        }),

        confirm() {
            if (this.selectedOption === this.clearOption) {
                this.clearCart();

                this.$toasted.success(
                    'סל הקניות רוקן בהצלחה, כעת אפשר לרכוש פריטים מחנות אחרת'
                );

                this.$emit('accepted');
            } else {
                if (this.redirectToCurrentShop && this.currentShopId) {
                    this.$router.push(`/shops/${this.currentShopId}`);
                }
            }

            this.$closeModal();
        }
    }
};
</script>
